export interface RegistrationDetails {
    userTitle:string;
    otherTitle:string;
    forename: string;
    surname: string;
    middleName: string,
    thirdName:string,
    dateOfBirth: string;
    emailAddress: string;
    confirmEmailAddress:string;
    maritalStatus: string;
    gender: string;
    postcode: string;
    ukaddressIndicator: string;
    addressline1: string;
    addressline2: string;
    addressline3: string;
    addressline4: string;
    homePhone:string;
    mobilePhone:string;
    internalSoftOptInInd: string;
    //country: string;

}